import React from 'react'
import { useI18n } from '../../i18n'
import { GovernanceListingSection } from '../governance/GovernanceListingSection'
import ReuseOpportunityCard from './ReuseOpportunityCard'
import type { EvidenceReuseCandidate } from '../../services/complianceReuseApi'

type Props = {
  candidates: EvidenceReuseCandidate[]
  busy?: boolean
  onConfirm: (id: string) => void
  onReject: (id: string) => void
}

export default function ReuseConfirmationQueue({ candidates, busy, onConfirm, onReject }: Props) {
  const { t } = useI18n()
  if (!candidates.length) return null

  return (
    <GovernanceListingSection
      title={t('complianceReuse.reuseOpportunities', 'Reuse opportunities')}
      description={t(
        'complianceReuse.queueHint',
        'Suggestions only — confirm or reject each reuse. Requirements are not auto-closed.',
      )}
    >
      <div className="flex flex-col gap-2">
        {candidates.map((c) => (
          <ReuseOpportunityCard key={c.id} candidate={c} busy={busy} onConfirm={onConfirm} onReject={onReject} />
        ))}
      </div>
    </GovernanceListingSection>
  )
}
